import Auth from '../Auth/Auth';
const auth = new Auth();

async function apiOptions(method, options) {
    let accessToken = await auth.getToken();   

    options ||= {};
    options.headers ||= {};
    options.headers['Authorization'] = 'Bearer ' + accessToken;

    const optionResponse = {
        method: method,
        headers: options.headers,
    };

    return optionResponse;
}

export const fetchAPI = {
    get,
    post
};

async function get(url, options) {
    const requestOptions = await apiOptions('GET', options);
    return fetch(url, requestOptions).then(handleResponse);
}

async function post(url, options) {
    const requestOptions = await apiOptions('POST', options);
    requestOptions.headers['Content-Type'] = 'application/json';        
    requestOptions.body = JSON.stringify(options.body);
    return fetch(url, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (response.status !== 200) {
        let payload = {
            status: response.status,
            rawmsg: response.statusText,
            cleanmsg: `${response.status} was thrown with the message of ${response.statusText} on ${response.url}`,
            location: response.url,
            timestamp: Date.now(),
        };
        throw {
            payload: payload,
            error: new Error()
        };
    }
    return response.json();
}